import { GetQuotaParams } from '@app/api/routes/quotaReports/types'

import type { TableData } from '@app/types/table'
import type { QuotaReportDirectoryDataSource } from '../types'
import type { ResponseDto } from '@app/api/dtos'
import type { QuotaDirectoriesDto } from '@app/api/routes/quotaReports/dtos'
import type { DecodedValueMap, QueryParamConfigMap } from 'use-query-params'

export const adaptQuotaReportDirectoryTableData = (
  quotaDirectoriesResponse: ResponseDto<QuotaDirectoriesDto>
): TableData<QuotaReportDirectoryDataSource> => {
  const { count, results: quotaDirectories } = quotaDirectoriesResponse

  const dataSource: QuotaReportDirectoryDataSource[] = quotaDirectories.map(dto => ({
    key: dto.id,
    monitoringType: dto.monitoringType?.name ?? null,
    cluster: dto.cluster?.name ?? null,
    clustersGroup: dto.clustersGroup?.name ?? null,
    store: dto.store?.name ?? null,
    salesOrganization: dto.salesOrganization?.name ?? null,
    trend: dto.trend?.name ?? null,
    trendId: dto.trend?.id ?? null,
    purchasingGroup: dto.purchasingGroup?.name ?? null,
    purchasingGroupId: dto.purchasingGroup?.id ?? null,
    commodityGroup: dto.commodityGroup?.name ?? null,
    commodityGroupId: dto.commodityGroup?.id ?? null,
    category: dto.category?.name ?? null,
    categoryId: dto.category?.id ?? null,
    subcategory: dto.subcategory?.name ?? null,
    subcategoryId: dto.subcategory?.id ?? null,
    brandCount: dto.brandCount ?? null,
    eppCount: dto.eppCount ?? null
  }))

  return { count, dataSource }
}

export const adaptGetQuotaParams = (queryParams: DecodedValueMap<QueryParamConfigMap>): GetQuotaParams => {
  return {
    monitoringTypeIds: queryParams.monitoringTypeIds,
    storeIds: queryParams.storeIds,
    clusterIds: queryParams.clusterIds,
    clustersGroupIds: queryParams.clustersGroupIds,
    salesOrganizationIds: queryParams.salesOrganizationIds
  }
}
